// ============================================================================
// LEDGER POSTING (Fairbooks posting register) ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/ledger-postings';

export const ledgerPostingEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  /** Re-drives a posting; rebuilds the payload from current mapping configuration. */
  retry: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/retry`, { id }),
} as const;

export default ledgerPostingEndpoints;
